export default "__VITE_ASSET__DK2Oy_fp__"